import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getDoneWorksOperationalMaterials: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].GET_DONE_WORKS_OPERATIONAL_MATERIALS,
	},
	getDoneWorksOperationalMaterialPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].GET_DONE_WORKS_OPERATIONAL_MATERIAL_PREVIEW,
	},
	getDoneWorksOperationalMaterialPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].GET_DONE_WORKS_OPERATIONAL_MATERIAL_POPUP,
	},
	createDoneWorksOperationalMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].CREATE_DONE_WORKS_OPERATIONAL_MATERIAL,
	},
	getDoneWorksOperationalMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].GET_DONE_WORKS_OPERATIONAL_MATERIAL,
	},
	patchDoneWorksOperationalMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].PATCH_DONE_WORKS_OPERATIONAL_MATERIAL,
	},
	putDoneWorksOperationalMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].PUT_DONE_WORKS_OPERATIONAL_MATERIAL,
	},
	deleteDoneWorksOperationalMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].DELETE_DONE_WORKS_OPERATIONAL_MATERIAL,
	},
}